export default __webpack_public_path__ + "static/vid-bg-c6e5cc3e0b20a86ed3b8e2d5bc3d3b44.mp4";